<p>view-emergency-info works!</p>
